<template>
  <div>
    <v-layout row class="ml-3 mt-3 mr-3">
      <span :class="ui.textSubheading">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Relationships Register
        </v-chip>
      </span>
      <v-spacer/>
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
          <v-icon>playlist_add</v-icon>
        </v-avatar>
        {{registerSize}}
      </v-chip>
    </v-layout>
    <v-layout row :class="ui.textSubheading">
      <v-spacer/>
      <!-- <Import :data="{tag: 'G6'}"/> -->
    </v-layout>
    <v-layout class="text-xs-left ml-4 mr-2 mt-2">
      <v-flex xs10 offset-xs1>
        <div :class="ui.textSubheading">
          The register allows interaction with other app documents to enhance business intelligence data. The relationship register is not available in current user access configuration.
        </div>
      </v-flex>
    </v-layout>
    <v-layout row :class="ui.textSubheading">
      <!-- <ImportList :data="{tag: 'G6'}"/> -->
    </v-layout>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
// import Import from "@/data/import/components/Import";
// import ImportList from "@/data/import/components/ImportList";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme],
  // eslint-disable-next-line
  components: {
    // Import,
    // ImportList
  },
  computed: {
    ...mapGetters(["getRelationshipRegister"]),
    registerSize() {
      let lengthSize = null;
      if (this.getRelationshipRegister === undefined) {
        lengthSize = 0;
      } else if (this.getRelationshipRegister === null) {
        lengthSize = 0;
      } else {
        lengthSize = this.getRelationshipRegister.length;
      }
      return lengthSize;
    }
  }
};
</script>
